// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageBadgesStyles } from "@insite/content-library/Components/ProductImageBadges";
import { hideElement } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productImageBadgesStyles.imageContainer = {
    css: css`
        justify-content: left;
        gap: 8px;
        padding-top: 8px;
        &:empty {
            ${hideElement}
        }
    `,
};

productImageBadgesStyles.imageItem = {
    css: css`
        justify-content: center;
        flex-basis: 20px;
        max-width: 20px;
        max-height: 20px;
        padding: 0;
    `,
};